import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { AdminSetupForm } from '@/features/auth/components/AdminSetupForm';
import { PageTransition } from '@/shared/motion';

export const Route = createFileRoute('/_auth/admin/setup')({
  component: AdminSetupRoute,
});

function AdminSetupRoute() {
  const navigate = useNavigate();
  return (
    <PageTransition>
      <AdminSetupForm
        onSuccess={() => {
          void navigate({ to: '/admin' });
        }}
      />
    </PageTransition>
  );
}
